export default __webpack_public_path__ + "locales/sk/Translations.json?hash=db03dadac4f6033ad6ed8165b44c63fe";